export default __webpack_public_path__ + "static/media/offline22.819e1ea8.png";